import React from 'react';
import styled from 'styled-components';
import Colors from '../../../../ui/global/Colors';
import LoadingSpinner from '../../../../ui/components/LoadingSpinner';
import AudioPlayer from '../../../../ui/components/AudioPlayer';

const Inner = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    gap: 10px;
`;

interface SoundInnerProps {
    loading: boolean;
    onSoundClick: (soundIndex: number) => void;
    selectedSoundIndex: number | null;
}

const SoundInner: React.FC<SoundInnerProps> = ({ loading, onSoundClick, selectedSoundIndex }) => {
    const gameSounds = [
        {
            title: 'First Example',
            src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
        },
        {
            title: 'Example 2 Long Title',
            src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
        },
        {
            title: 'Third',
            src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
        }
    ];

    return (
        <Inner>
            {loading ? (
                <LoadingSpinner size="medium" colorMode="dark" />
            ) : (
                gameSounds.length > 0 ? (
                    gameSounds.map((sound, index) => (
                        <AudioPlayer
                            key={index}
                            title={sound.title}
                            src={sound.src}
                            colorMode="dark"
                            variant="mini"
                            onBackgroundClick={() => onSoundClick(index)}
                            isSelected={selectedSoundIndex === index}
                        />
                    ))
                ) : (
                    <div style={{ color: Colors.grey3, textAlign: 'center', padding: '20px 0' }}>
                        No sounds added yet
                    </div>
                )
            )}
        </Inner>
    );
};

export default SoundInner;